import type { L2FilterOption } from 'ace/filterSection';

/** Source-neutral catalog nodes for the existing flat/two-level filter controls. */
export interface FilterCatalogNode {
    id: string;
    name: string;
}

export interface FilterCatalogOption extends FilterCatalogNode {
    children?: FilterCatalogNode[];
}

export interface FilterCatalogPolicy {
    resolveLabel: (node: FilterCatalogNode, parent?: FilterCatalogNode) => string;
    resolveValue: (node: FilterCatalogNode, parent?: FilterCatalogNode) => string;
}

/** Display labels and URL/Search values are independent policies, never identities. */
export function buildCatalogFilterOptions(
    catalog: FilterCatalogOption[],
    policy: FilterCatalogPolicy,
): L2FilterOption[] {
    return catalog.map((parent) => {
        const childValues = new Set<string>();
        return {
            id: parent.id,
            label: policy.resolveLabel(parent),
            value: policy.resolveValue(parent),
            isL2Filter: Boolean(parent.children?.length),
            multiple: true,
            options: (parent.children ?? []).flatMap((child) => {
                const value = policy.resolveValue(child, parent);
                // One query value is one checkbox per group; retain the first source identity and label.
                if (childValues.has(value)) {
                    return [];
                }
                childValues.add(value);
                return [{ id: child.id, label: policy.resolveLabel(child, parent), value }];
            }),
        };
    });
}
